import { render, staticRenderFns } from "./MultiColumnsBlockListItem.vue?vue&type=template&id=17b2f2d0"
import script from "./MultiColumnsBlockListItem.vue?vue&type=script&lang=ts"
export * from "./MultiColumnsBlockListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports